import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { backendBase } from '../utils/backendApi';

const INTEREST = [
  ['platform', 'Platform Enterprise'],
  ['kit', 'Kit Enterprise'],
  ['both', 'Both'],
];
const SEATS = [
  ['under-25', 'Under 25'],
  ['25-100', '25–100'],
  ['100-plus', '100+'],
];
const TIMELINE = [
  ['month', 'This month'],
  ['quarter', 'This quarter'],
  ['exploring', 'Exploring'],
];

function Field({ label, children }) {
  return (
    <div className="cs-field">
      <label>{label}</label>
      {children}
    </div>
  );
}

export default function EnterpriseInquiry() {
  const [form, setForm] = useState({
    name: '', email: '', company: '', interest: 'platform', seats: '25-100', timeline: 'quarter', brief: '',
  });
  const [website, setWebsite] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const set = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    const base = backendBase();
    if (!base) {
      setError('Email hello@nventr.io and we’ll set the review.');
      return;
    }
    setBusy(true);
    try {
      const res = await fetch(`${base}/leads/enterprise`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, website }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || 'Could not send that.');
      setDone(true);
    } catch (err) {
      setError(err.message || 'Could not send that. Email hello@nventr.io.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="cs-ent-review">
      <div className="cs-sw-card">
        <p className="cs-mod-kicker">What happens next</p>
        <h3>30-minute enterprise review</h3>
        <p>
          Bring the systems you already use, or the app you need people to
          open, and the write that has to stay gated.
        </p>
        <ol className="cs-ent-steps">
          <li>
            <strong>You send the brief</strong>
            <span>Company, which product, and the workflow that has to be right.</span>
          </li>
          <li>
            <strong>We name the first write</strong>
            <span>Platform, Kit, or both — and what the gate has to hold.</span>
          </li>
          <li>
            <strong>Review call</strong>
            <span>30 minutes. No slide deck.</span>
          </li>
        </ol>
        <p className="cs-ent-meta">
          <span>Typical reply</span> Under 1 business day
          <span>Write us</span> <Link to="/contact">Contact form</Link>
        </p>
      </div>
      {done ? (
        <div className="cs-sw-card">
          <h3>We’ll reply within one business day</h3>
          <p>The review is 30 minutes. We’ll use the brief you sent.</p>
        </div>
      ) : (
        <form className="cs-sw-card" onSubmit={submit}>
          <p className="cs-mod-kicker">Send a brief</p>
          <h3>Tell us what you run</h3>
          <div className="cs-ent-grid">
            <Field label="Name">
              <input className="cs-input" required value={form.name} onChange={set('name')} autoComplete="name" />
            </Field>
            <Field label="Work email">
              <input className="cs-input" required type="email" value={form.email} onChange={set('email')} autoComplete="email" />
            </Field>
            <Field label="Company">
              <input className="cs-input" required value={form.company} onChange={set('company')} autoComplete="organization" />
            </Field>
            <Field label="Seats">
              <select className="cs-input" value={form.seats} onChange={set('seats')}>
                {SEATS.map(([id, label]) => <option key={id} value={id}>{label}</option>)}
              </select>
            </Field>
            <Field label="Interested in">
              <select className="cs-input" value={form.interest} onChange={set('interest')}>
                {INTEREST.map(([id, label]) => <option key={id} value={id}>{label}</option>)}
              </select>
            </Field>
            <Field label="Timeline">
              <select className="cs-input" value={form.timeline} onChange={set('timeline')}>
                {TIMELINE.map(([id, label]) => <option key={id} value={id}>{label}</option>)}
              </select>
            </Field>
          </div>
          <Field label="What should the first write do?">
            <textarea
              className="cs-input"
              required
              rows={4}
              minLength={8}
              value={form.brief}
              onChange={set('brief')}
              placeholder="The system or app, who is live on it today, your timeline, and what must wait for a gate — or say if you need nventr to run Dev Console for you (Kit Enterprise named support) vs self-serve on Kit."
            />
          </Field>
          <div className="cs-hp" aria-hidden="true">
            <label>
              Website
              <input tabIndex={-1} autoComplete="off" value={website} onChange={(e) => setWebsite(e.target.value)} />
            </label>
          </div>
          {error && <p className="cs-land-micro">{error}</p>}
          <button className="cs-btn cs-btn-primary" type="submit" disabled={busy}>
            {busy ? 'Sending…' : 'Request the review'}
          </button>
        </form>
      )}
    </div>
  );
}
